export default {
  toasts: {
    verification_pending: 'Din verificering afventer stadig',
  },
};
